import { AttribuateDriverInput, DedicatedPackageOutput } from '@allocab/allocab-dedicated-driver-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const refuseTriPackageToDriver = (packageId: string, input: AttribuateDriverInput) =>
  driverApi.post<AttribuateDriverInput, DedicatedPackageOutput>(
    `/v1/dedicated-package/${packageId}/manager/refuse`,
    input,
  );

export const useRefuseTriPackageToDriver = (packageId: string) =>
  useMutation<DedicatedPackageOutput, unknown, AttribuateDriverInput>({
    mutationFn: input => refuseTriPackageToDriver(packageId, input),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.user.fetchTripPackages());
      queryClient.invalidateQueries(queryKeys.user.fetchInfiniteTripPackages());
    },
  });
